module.exports = __webpack_public_path__ + "img/imperial.1e34c950.png";